import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "@/lib/api";

export default function Referral() {
  const { token } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    API.get(`/referrals/${token}`)
      .then((r) => {
        try { sessionStorage.setItem("fydate_ref", JSON.stringify({ token, request_id: r.data.request_id })); } catch {}
        navigate(`/request/${r.data.request_id}`, { replace: true });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [token]);
  return (
    <div className="min-h-screen bg-[#EEF1F7] flex items-center justify-center">
      <p className="text-[#4A4E68]">Apertura della richiesta...</p>
    </div>
  );
}
